import { render, staticRenderFns } from "./App.vue?vue&type=template&id=28882b2d&scoped=true&"
import script from "./App.vue?vue&type=script&lang=js&"
export * from "./App.vue?vue&type=script&lang=js&"
import style0 from "./App.vue?vue&type=style&index=0&id=28882b2d&prod&lang=less&scoped=true&"
import style1 from "./App.vue?vue&type=style&index=1&id=28882b2d&prod&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28882b2d",
  null
  
)

export default component.exports